<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->

<div mat-dialog-container>
  <div mat-dialog-title>
    {{ data.title }}
    <button mat-icon-button (click)="handleEditComplete(false)" title="Cancel" class="close-button" tabindex="-1">
      <mat-icon class="mdi-24px self-center" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
  </div>
  @if (data && data.move) {
  <div mat-dialog-content>
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>Move Number</mat-label>
          <input type="text" matInput [(ngModel)]="data.move.moveNumber" placeholder="Move Number">
        </mat-form-field>
      </div>
    </div>
    <!-- move start time (deltaSeconds) -->
    <div class="add-margin flex-row">
      <app-duration-edit [startTime]="data.mselStartTime" [(durationSeconds)]="data.move.deltaSeconds"
        [timeName]="'Start Date / Time'" [postScript]="'from start'">
      </app-duration-edit>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="full-width">
          <mat-label>Move Description</mat-label>
          <input type="text" matInput [(ngModel)]="data.move.description" placeholder="Move Description">
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin">
      <div>
        <mat-form-field class="datetime-field">
          <mat-label>Situation Date / Time</mat-label>
          <input matInput [ngxMatDatetimePicker]="picker" [formControl]="situationDateFormControl"
            (inputChange)="saveMove('situationDate')" (dateChange)="saveMove('situationDate')" style="display: none;">
          <!-- <datetime-picker> -->
          <span (click)="picker.open()">
            {{ situationDateFormControl.value | date: 'dd MMM yyyy HH:mm' }} {{ getTimezoneAbbr() }}
          </span>
          <mat-datepicker-toggle matSuffix title="Choose Date/Time" [for]="picker">
          </mat-datepicker-toggle>
          <ngx-mat-datetime-picker #picker [showSpinners]=true [showSeconds]=false [stepHour]=1 [stepMinute]=5
            [stepSecond]=1 [touchUi]=false [enableMeridian]=true [disableMinute]=false [hideTime]=false
            [color]="'warn'">
            <ngx-mat-datepicker-actions>
              <button mat-stroked-button ngxMatDatepickerApply>Save</button>
              <button mat-stroked-button ngxMatDatepickerCancel>Cancel</button>
            </ngx-mat-datepicker-actions>
          </ngx-mat-datetime-picker>
        </mat-form-field>
      </div>
    </div>
    <div class="add-margin left">
      <div>
        <p style="font-size: 13px; font-weight: 400; line-height: 1.125; letter-spacing: normal;">
          Situation Description
        </p>
        <div>
          <angular-editor [placeholder]="'Description'" [(ngModel)]="data.move.situationDescription"
            [config]="editorConfig"></angular-editor>
        </div>
      </div>
    </div>
  </div>
  }
  <div class="cssLayoutRowStartCenter bottom-button">
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(true)" style="margin-left: 40px;">Save</button>
    </div>
    <div class="delete-button">
      <button mat-stroked-button (click)="handleEditComplete(false)">Cancel</button>
    </div>
  </div>
</div>
